//imports
import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Container, } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

export default function FAQ({ fre, handleChange, expanded }) {

    return (
        //This is the container that is called by the "FAQ.js" page 
        //It repeats the amount of questions stored in DB
        <>
            <Container>
                <Accordion square expanded={expanded === fre.id} onChange={handleChange(fre.id)}>
                    <AccordionSummary aria-controls="panel1d-content" id="panel1d-header"
                        expandIcon={<ExpandMoreIcon />}
                    >
                        <h4 component="header">{fre.question}</h4>
                    </AccordionSummary>
                    <AccordionDetails>
                        <h5 className="description" component="header" style={{color:"#000000"}}>{fre.answer}</h5>
                    </AccordionDetails>
                </Accordion>
            </Container>
        </>

    );
}